import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsRuleTemplate extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public conditionsFields: any;

  @Expose()
  public objectTypes: any;

  @Expose()
  public description: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
